const suppliersMockData = {
    "type": "SUCCESS_SUPPLIER_NAMES_ACTION",
    "companyNameAndSupplierType": {
        "Ag": [
            "ADM",
            "AFGRI MILLING",
            "Agrana",
            "Ajinomoto",
            "ALLIED PINNACLE PTY LTD",
            "AMCO",
            "Ardion",
            "Arma",
            "Aston",
            "Austria Juice",
            "Avril",
            "Azucarera",
            "Barry Callebaut",
            "Berje Inc",
            "Bester Voere",
            "Bimal",
            "British Sugar",
            "Bunge",
            "Cargill",
            "Celanese",
            "Citrosuco",
            "COFCO",
            "COPERSUCAR SA",
            "CORSON GRAIN LTD",
            "Cosun",
            "Cosun Beet Company",
            "CristalCo",
            "DDW",
            "Doehler",
            "Domino",
            "EFKO",
            "ELITA GIDA SAN. VE TIC. A. S.",
            "Emsland",
            "Ensign",
            "Firmenich – DSM",
            "Gadot",
            "GAM",
            "General Mills",
            "GIVAUDAN",
            "Golden Era",
            "Gotrade Enterprises Limited",
            "GRAINCO PTY LTD",
            "Graincorp",
            "HSWT",
            "IFFCO",
            "INGREDION",
            "INTEGRADA COOPERATIVA AGROINDUSTRIA",
            "INTERNATIONAL FLAVOURS & FRAGRANCES",
            "Italia Zuccheri Commerciale Srl",
            "Jinhe",
            "KAAP AGRI",
            "KERRY INGREDIENTS",
            "KSC",
            "LACHLAN COMMODITIES",
            "Lamsoon Oil",
            "LAND O LAKES INC",
            "LDC",
            "LIFELINE FOODS",
            "Lipidos",
            "Liu HuaJian",
            "Maslenitsa",
            "MCCORMICK & CO",
            "Mercoguardiana",
            "National Sugar Marketing",
            "Nigay",
            "NILE SUGAR COMPANY",
            "Nordzucker",
            "Novatex",
            "NWK Beperk",
            "Oleofinos",
            "Overberg Agri",
            "Perdigon",
            "Perfect Partner (Ag)",
            "Petrogroup",
            "Pfeifer & Langen",
            "President Nisshin",
            "Primient",
            "Prodimex",
            "Producers Rice Mill Inc",
            "Raizen",
            "Rixona",
            "Rusagro",
            "Savola",
            "Seaboard",
            "Senwes",
            "Sethness",
            "Siegfried",
            "Silostrat",
            "Simedarby Oil Morakot",
            "Sinosweet",
            "Sovena",
            "Soya Mills",
            "Sucden",
            "Sudzucker",
            "SYMRISE",
            "T&L",
            "Team Foods",
            "Tereos",
            "Trimex",
            "TUTGU GIDA",
            "United Sugars",
            "Unity",
            "Usina São José Pinheiro (USJP)",
            "USJ ACUCAR E ALCOOL SA",
            "Vandamme",
            "Vitasweet",
            "Willowton",
            "Wilmar"
        ],
        "Pack": [
            "ALCOA WARRICK LLC",
            "Alpla",
            "Amcor Flex Europe",
            "Amcor plc",
            "American Fuji Seal",
            "American Poly",
            "Anchor",
            "Arabian Packages",
            "ARCONIC US LLC",
            "Ardagh Glass",
            "Ardagh Metal",
            "AVADHOOT PAPER PRODUCTS PRIVATE LTD",
            "BA Glass",
            "Ball",
            "Bariq",
            "Benepack",
            "BERICAP",
            "Berlin",
            "BERRY Global",
            "Biopappel",
            "Bryce",
            "Can-Pack",
            "Cartolito",
            "CEPACK FOR PACKAGING MATERIAL",
            "ColorMasters",
            "Constantia",
            "CONTINENTAL CORRUGATORS (P) LIMITED",
            "Corruseal",
            "Crown",
            "CSI",
            "Cumapol",
            "DAK",
            "DB Schenker",
            "Display Technologies/Marmon",
            "DS Smith",
            "DUYTAN VIETNAM",
            "Eastman",
            "EGYPT CANADIAN COMPANY FOR CARTONS",
            "Electric80",
            "Elopak",
            "EMUSA",
            "FENC",
            "Flexstar packaging",
            "FTMM (Packsol)",
            "GOLDEN ALUMINUM",
            "Gotek",
            "GPI",
            "GRAHAM GPS",
            "GRAINCO PTY LTD",
            "Graphic Packaging",
            "GreatView",
            "Group O",
            "Heat and Control",
            "Helvetia Packaging",
            "Hertex (ECO Polymers)",
            "HH-Global",
            "Hiang Seng",
            "Hu Bei He Xing Packaging Co.,Ltd",
            "Hu Bei He Xing Packing Co.,Ltd",
            "Huhtamaki",
            "IFP",
            "Indorama",
            "INTER CO FOR PACKING",
            "Interflex",
            "International Paper",
            "Interpress",
            "Interstate Packaging",
            "ITW Hi Cone",
            "Jindal",
            "KAISER ALUMINUM WARRICK LLC",
            "Kameda Seika",
            "Keune & Nagel",
            "Lamipak",
            "Manucor",
            "Markforged",
            "MCC Label-  (Fort Dearborn)",
            "MCC Label-  (Fort Dearborn)",
            "Mecalux",
            "MEKKA for Trade and Industry (Mahmoud Said)",
            "Meltem",
            "Mercoguardiana",
            "METAL CONTAINER CORP",
            "Middle East Glass Misr Glass Manufacturing",
            "MM Packaging",
            "Modern",
            "Modern Ambalaj",
            "Mondi Group",
            "Muraplast",
            "Nanshan",
            "NEO Group",
            "NEOPET",
            "Nijhuis",
            "Nile Delta El Nile",
            "Novel",
            "NOVELIS CORP",
            "NWK Beperk",
            "OBX",
            "Olam",
            "OMT",
            "Owens Illinois",
            "Pacific Southwest Container",
            "Perfect Partner (Pack)",
            "Petstar",
            "Pilenpak",
            "Plarus",
            "Plastipak",
            "Polibak",
            "Polytech",
            "Printpack",
            "RCS",
            "Retal",
            "Romcarton",
            "Roshan Packages",
            "Rotografia Group",
            "RTC",
            "Scientex (Daibochi Berhad)",
            "Seaboard",
            "Senege",
            "Sepas",
            "Shanghai Jin Liang Paper Co., Ltd.",
            "Sibur",
            "SIG",
            "SIGMAPLAST",
            "SILGAN CLOSURES",
            "Sisecam",
            "SKC Film Inc.",
            "SKChemical",
            "Smurfit Kappa",
            "Srichakra",
            "Taghleef Industries Inc",
            "TECNOVAL",
            "Tereos",
            "TetraPak",
            "Thai Container",
            "Toray Films Europe",
            "Toray Plastics NA",
            "TRI ARROWS ALUMINUM INC",
            "UFLEX LIMITED",
            "UNITED CARTON INDUSTRIES",
            "Veolia",
            "Verpa",
            "Vidrala S.A.",
            "VW",
            "WestRock",
            "Xiangheng",
            "Yara",
            "Yu Bin and Yu Jiang",
            "Zumbiel"
        ]
    },
    "regenValues": [
        "Ag",
        "Pack"
    ]
}

const sustainabilityData = {
    "kpiDetailCardDtoList": [
        {
            "title": "Leader Ladder Score",
            "currentYearValue": "0.0",
            "lastYearValue": "0.0",
            "colour": "#FFCC49",
            "lastUpdate": "",
            "refreshFrequency": "",
            "status": "INITIATING"
        },
        {
            "title": "SBT Status",
            "currentYearValue": "0.0",
            "lastYearValue": "0.0",
            "colour": "#FFCC49",
            "lastUpdate": "",
            "refreshFrequency": "",
            "status": "INITIATING"
        },
        {
            "title": "Emissions and Energy Reported",
            "currentYearValue": "0.0",
            "lastYearValue": "0.0",
            "colour": "#FFCC49",
            "lastUpdate": "",
            "refreshFrequency": "",
            "status": "INITIATING"
        },
        {
            "title": "Renewable Fuel%",
            "currentYearValue": "0.0",
            "lastYearValue": "0.0",
            "colour": "#FFCC49",
            "lastUpdate": null,
            "refreshFrequency": null,
            "status": "INITIATING"
        },
        {
            "title": "Renewable Electricity%",
            "currentYearValue": "0.0",
            "lastYearValue": "0.0",
            "colour": "#FFCC49",
            "lastUpdate": null,
            "refreshFrequency": null,
            "status": "INITIATING"
        },
        {
            "title": "Regen Ag Status",
            "currentYearValue": "NA",
            "lastYearValue": "NA",
            "colour": "#FFCC49",
            "lastUpdate": "NA",
            "refreshFrequency": 'NA',
            "status": "INITIATING"
        }
    ],
    "pieChartDataDtoList": [
        {
            "name": "Emissions Reporting",
            "value": "0.0"
        },
        {
            "name": "Energy Data Reporting",
            "value": "0.0"
        },
        {
            "name": "Science-Based Target",
            "value": "0.0"
        },
        {
            "name": "Guidehouse",
            "value": "0.0"
        },
        {
            "name": "ReNew",
            "value": "0.0"
        },
        {
            "name": "Energy Profile",
            "value": "0.0"
        },
        {
            "name": "CDP Score",
            "value": "0.0"
        },
        {
            "name": "Decarb Plan",
            "value": "0.0"
        },
        {
            "name": "Regen Ag",
            "value": "NA"
        },
        {
            "name": "Regen Ag",
            "value": "0.0"
        }
    ]
}

// const sustainabilityData = [
//     {
//         "title": "Leader Ladder Score",
//         "currentYearValue": "0.0",
//         "lastYearValue": "0.0",
//         "colour": "",
//         "lastUpdate": "",
//         "refreshFrequency": "",
//         "status": ""
//     },
//     {
//         title: 'SBT Status',
//         currentYearValue: 5.4,
//         lastYearValue: 5.3,
//         color: '#75CD12',
//         lastUpdate: '11/15/23',
//         refreshFrequency: 'Yearly',
//         status: 'ACCELERATING'
//     },
//     {
//         title: 'Renewable Fuel %',
//         currentYearValue: 5.4,
//         lastYearValue: 5.3,
//         color: '#75CD12',
//         lastUpdate: '11/15/23',
//         refreshFrequency: 'Yearly',
//         status: 'ACCELERATING'
//     },
//     {
//         title: 'Renewable Electricity %',
//         currentYearValue: 5.4,
//         lastYearValue: 5.3,
//         color: '#33ABDA',
//         lastUpdate: '11/15/23',
//         refreshFrequency: 'Yearly',
//         status: 'Engaging'
//     },
//     {
//         title: 'Regen Ag Status',
//         currentYearValue: 5.4,
//         lastYearValue: 5.3,
//         color: '#005CBC',
//         lastUpdate: '11/15/23',
//         refreshFrequency: 'Yearly',
//         status: 'Progressing'
//     },
//     {
//         title: 'Emissions and Energy Reported',
//         currentYearValue: 5.4,
//         lastYearValue: 5.3,
//         color: '#75CD12',
//         lastUpdate: '11/15/23',
//         refreshFrequency: 'Yearly',
//         status: 'ACCELERATING'
//     },
// ]

const regenDropdownData = [
    { displayText: 'Ag', id: 1 },
    { displayText: 'Pack', id: 2 },
]


const legendColor = {
    'Emissions Reporting': '#33ABDA',
    'Regen Ag': '#FF891C',
    'Energy Profile': '#c0c0c0',//'#DFDFDF',
    'Energy Data Reporting': '#B05788',
    'Regen Ag Projects': '#6A3452',
    'CDP Score': '#616161',
    'Science-Based Target': '#0078A7',
    'Guidehouse': '#995211',
    'Decarb Plan': '#002D3F',
    'RE or Fuel Goal': '#8458CC',
    'ReNew': '#4F357A'
};


const ladderScoreLegend = [
    { color: '#006A42', title: 'Leader', value: '(100% or 5+)', text: 'Supplier is leading in one or more of pep+ agenda' },
    { color: '#75CD12', title: 'Accelerating', value: '(75-90% or 4 to 4.9)', text: 'Supplier is accelerating and close to reaching leader status' },
    { color: '#005CBC', title: 'Progressing', value: '(50-75% or 3 to 3.9)', text: 'Supplier is committed and is making good progress' },
    { color: '#33ABDA', title: 'Engaging', value: '(25-50% or 2 to 2.9)', text: 'supplier is engaging in pep+' },
    { color: '#FFCC49', title: 'Initiating', value: '(< 25%  or < 2)', text: 'first step in the journey and the conversation to move to green' },
]

const leaderLadderLegend = {
    Leader: '#006A42',
    Accelerating: '#75CD12',
    Progressing: '#005CBC',
    Engaging: '#33ABDA',
    Initiating: '#FFCC49'
}

const dataSourceLegends = [
    { name: 'Emissions Reporting', value: 400 },
    { name: 'Regen Ag', value: 143 },
    { name: 'Energy Profile', value: 294 },
    { name: 'Energy Data Reporting', value: 453 },
    { name: 'Regen Ag Projects', value: 198 },
    { name: 'CDP Score', value: 300 },
    { name: 'Science-Based Target', value: 200 },
    { name: ' Guidehouse', value: 100 },
    { name: 'Decarb Plan', value: 244 },
    { name: 'RE or Fuel Goal', value: 239 },
    { name: 'ReNew', value: 392 },
]

export { suppliersMockData, sustainabilityData, regenDropdownData, legendColor, ladderScoreLegend, dataSourceLegends, leaderLadderLegend }